// Cambia a true cuando exista el número oficial de WhatsApp para volver a mostrar todos los botones.
export const WHATSAPP_ENABLED = false;

export const waProps = (url) =>
  WHATSAPP_ENABLED ? { href: url, target: "_blank", rel: "noreferrer" } : { href: "/contacto" };

export const waLabel = (pick, es, en, pt) =>
  WHATSAPP_ENABLED ? pick(es, en, pt) : pick("Contáctanos", "Contact us", "Fale conosco");
